export const AuthorFragment = `
  id
  username
  displayName
  displayNameOrUsername
  avatar
  role
  profileID
  profileURL
  isTrusted
  createdAt
`;

export const RecReplyFragment = `
recs
replyCount
isRecced
`;

export const PollFragment = `
id
shortID
pollData {
  options {
    id
    name
  }
  endsAt
}
pollResults {
  choice
  count
}
myChoice
isOpen
`;

export const ExternalRootFragment = `
  id
  shortID
  parentID
  type
  modStatus
  createdAt
  deletedAt
  keywords
  repliesAreClosed
  urls
  friendlyID
  directReplyCount
  replyCount
  community {
    id
    cacheID
    type
    name
  }
  viewerCount
`;

export const FanPostFragment = `parentID
title
body
id
shortID
modStatus
author {
  ${AuthorFragment}
}
attachments {
  url
  type
  id
  ... on LinkAttachment {
    ogTitle
    ogDescription
    ogImage {
      url
      altText
    }
    ogSiteName
    publishedAt
    favicon
  }
  ... on TwitterAttachment {
    html
    heightToWidthRatio
  }
  ... on YoutubeAttachment {
    html
    thumbnailUrl
  }
  ... on UploadedAttachment {
    altText
    height
    width
  }
  ... on GifAttachment {
    altText
    thumbnailUrl
  }
  ... on InstagramAttachment {
    heightToWidthRatio
    html
    thumbnailUrl
  }
  ... on TikTokAttachment {
    html
    heightToWidthRatio
    thumbnailUrl
  }
  ... on BlueskyAttachment {
    html
    heightToWidthRatio
    thumbnailUrl
  }
}
community {
  id
  cacheID
  type
  name
}
createdAt
deletedAt
${RecReplyFragment}
directReplyCount
isReccedByStaff
isReported
isLegacy
type
repliesAreClosed
adOnly
poll {
  ${PollFragment}
}
`;

export const NoteFragment = `
id
shortID
venueID
body
createdAt
deletedAt
modStatus
type
isPrivate
isEdited
isRecced
isReported
recs
replyCount
directReplyCount
author {
  ${AuthorFragment}
}
community {
  id
  cacheID
  name
}
attachments {
  url
  type
  id
  ... on UploadedAttachment {
    altText
    height
    width
  }
  ... on GifAttachment {
    altText
    thumbnailUrl
  }
}
`;

export const QuickPostFragment = `id
shortID
parentID
createdAt
deletedAt
modStatus
type
keywords
repliesAreClosed
community {
  id
  cacheID
  name
}
... on QuickPost {
  rootAncestorID
  rootAncestor {
    type
    shortID
    ... on ExternalRoot {
      urls
    }
  }
  opener
  body
  author {
    ${AuthorFragment}
  }
  isSponsored
  isPinned
  pinnedAt
  isRecced
  isReported
  isEdited
  recs
  replyCount
  directReplyCount
  seen
  attachments {
    type
    url
    id
    ... on GifAttachment {
      altText
      thumbnailUrl
    }
    ... on TwitterAttachment {
      html
      heightToWidthRatio
    }
    ... on YoutubeAttachment {
      html
      thumbnailUrl
    }
    ... on InstagramAttachment {
      html
      heightToWidthRatio
      thumbnailUrl
    }
    ... on TikTokAttachment {
      html
      heightToWidthRatio
      thumbnailUrl
    }
    ... on BlueskyAttachment {
      html
      heightToWidthRatio
      thumbnailUrl
    }
    ... on LinkAttachment {
      ogTitle
      ogDescription
      ogImage {
        url
        altText
      }
      ogSiteName
      publishedAt
      favicon
    }
    ... on UploadedAttachment {
      altText
      height
      width
    }
  }
}`;

/**
 * Queries/fragments for admin tools
 */
export const UserAdminQueryFragment = `
id
username
email
role
createdAt
avatar
communities
status
restrictions {
  type
  allCommunities
  communityID
  expiresAt
}
  trustedInCommunities {
    name
    id
  }
`;

export const UserMessageFragment = `
id
type
message
createdAt
acknowledgedAt
`;

export const userByEmailAdminQuery = `
  query UserAdminQuery($email:String!) {
    user(email:$email) {
      ${UserAdminQueryFragment}
    }
  }
`;
